var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "container" } }, [
    _c("div", { staticClass: "banner1" }, [
      _c("div", { staticClass: "content-barea" }, [
        _c("div", { staticClass: "banner1-title" }, [
          _c("h1", { staticStyle: { color: "white" } }, [
            _vm._v("MyStreet SF")
          ]),
          _c("p", [
            _vm._v(
              "Project Details: " +
                _vm._s(_vm.geojson["sponsor"]) +
                " Project " +
                _vm._s(_vm.project_number)
            )
          ])
        ]),
        _vm._m(0)
      ])
    ]),
    _c("div", { staticClass: "banner2" }),
    _c("div", { attrs: { id: "project-detail-container" } }, [
      _c("div", { attrs: { id: "main-column" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.project_name))]),
        _c("div", { staticClass: "brief-info" }, [
          _c("h3", { staticClass: "billy-header", style: _vm.color }, [
            _vm._v("Brief Project Description")
          ]),
          _c("p", { staticClass: "project-description" }, [
            _vm._v(_vm._s(_vm.description))
          ])
        ]),
        _c("div", { staticClass: "detailed-info" }, [
          _c("h3", { staticClass: "billy-header", style: _vm.color }, [
            _vm._v("Detailed Project Information")
          ]),
          _c(
            "table",
            _vm._l(_vm.details, function(row) {
              return _c("tr", { staticClass: "project-details" }, [
                _c("td", { staticClass: "project-details" }, [
                  _c("b", { domProps: { innerHTML: _vm._s(row[0]) } })
                ]),
                _c("td", { staticClass: "project-details col2" }, [
                  _vm._v(_vm._s(row[1]))
                ])
              ])
            }),
            0
          )
        ]),
        _c("div", { staticClass: "for-more-info" }, [
          _c("h3", { staticClass: "billy-header", style: _vm.color }, [
            _vm._v("For More Information")
          ]),
          _c("p", [
            _c(
              "a",
              { attrs: { href: _vm.forMoreInfoLink, target: "_blank" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.forMoreInfoLinkText.length < 85
                      ? _vm.forMoreInfoLinkText
                      : _vm.forMoreInfoLinkText.substring(0, 85) + "…"
                  )
                )
              ]
            )
          ])
        ])
      ]),
      _c("div", { attrs: { id: "nav-column" } }, [
        _vm.project_name
          ? _c("div", { attrs: { id: "nav-links" } }, [
              _c(
                "button",
                {
                  staticClass: "ui button small basic labeled icon violet",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.clickedBack }
                },
                [
                  _c("i", { staticClass: "icon", class: _vm.backButtonIcon }),
                  _vm._v(_vm._s(_vm.backButtonText))
                ]
              )
            ])
          : _vm._e(),
        !_vm.isCitywide
          ? _c("div", { staticClass: "widget" }, [
              _c("p", { style: _vm.color }, [_vm._v("Project Location")]),
              _c("div", { attrs: { id: "zoom-map" } })
            ])
          : _vm._e(),
        _c("div", { staticClass: "widget" }, [
          _c("p", { style: _vm.color }, [_vm._v("Share this!")]),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://twitter.com/intent/tweet?text=" +
                  _vm.cleanProjectName +
                  " " +
                  _vm.currentRoute,
                title: "Twitter"
              }
            },
            [_c("img", { attrs: { src: require("../assets/twitter.png") } })]
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://www.facebook.com/sharer/sharer.php?u=" +
                  _vm.currentRoute,
                title: "Facebook"
              }
            },
            [_c("img", { attrs: { src: require("../assets/fb.png") } })]
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://pinterest.com/pin/create/button/?url=" +
                  _vm.currentRoute,
                title: "Pinterest"
              }
            },
            [_c("img", { attrs: { src: require("../assets/pinterest.png") } })]
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://www.linkedin.com/shareArticle?mini=true&url=" +
                  _vm.currentRoute +
                  "&title=" +
                  _vm.cleanProjectName,
                title: "LinkedIn"
              }
            },
            [_c("img", { attrs: { src: require("../assets/linkedin.png") } })]
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://www.reddit.com/submit?url=" +
                  _vm.currentRoute +
                  "&title=" +
                  _vm.cleanProjectName,
                title: "Reddit"
              }
            },
            [_c("img", { attrs: { src: require("../assets/reddit.png") } })]
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "mailto:?&subject=" +
                  _vm.cleanProjectName +
                  "&body=Check out the SFCTA MyStreet project page for:%0D%0A%0D%0A" +
                  _vm.cleanProjectName +
                  "%0D%0A" +
                  _vm.currentRoute,
                title: "Email"
              }
            },
            [_c("img", { attrs: { src: require("../assets/email.png") } })]
          )
        ])
      ])
    ]),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agency-logo" }, [
      _c(
        "a",
        {
          staticClass: "agency-link",
          attrs: { target: "_blank", href: "https://www.sfcta.org/" }
        },
        [
          _c("img", {
            staticClass: "img-logo",
            attrs: { src: require("../assets/sfcta-logo.png") }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "banner2" }),
      _c("div", { staticClass: "banner1" }, [
        _c("div", { staticClass: "content-barea" }, [
          _c("p", [
            _vm._v(
              "All content © 2018 San Francisco County Transportation Authority."
            )
          ]),
          _c("br")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e184748", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e184748","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectPage.vue
// module id = null
// module chunks = 